
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Spinner from 'vue-simple-spinner'

type Type = 'button' | 'reset' | 'submit'
/*
  Primary buttons have a colourful solid background
  Secondary have a white background and colourful text
  Both can be muted or disabled.
  The icon name, if any, is passed in.
*/

@Component<BaseButton>({
    components: {
        Spinner,
    },
})
export default class BaseButton extends Vue {
    @Prop({ type: Function, required: false }) public click?: () => void
    @Prop({ type: Boolean, required: false }) public primary?: boolean
    @Prop({ type: Boolean, required: false }) public newPrimary?: boolean
    @Prop({ type: Boolean, required: false }) public grey?: boolean
    @Prop({ type: Boolean, required: false }) public white?: boolean
    @Prop({ type: Boolean, required: false }) public transparent?: boolean
    @Prop({ type: Boolean, required: false }) public red?: boolean
    @Prop({ type: Boolean, required: false }) public green?: boolean
    @Prop({ type: Boolean, required: false }) public secondary?: boolean
    @Prop({ type: Boolean, required: false }) public newSecondary?: boolean
    @Prop({ type: Boolean, required: false }) public caution?: boolean
    @Prop({ type: Boolean, required: false }) public muted?: boolean
    @Prop({ type: Boolean, required: false }) public disabled?: boolean
    @Prop({ type: Boolean, required: false }) public large?: boolean
    @Prop({ type: Boolean, required: false }) public small?: boolean
    @Prop({ type: Boolean, required: false }) public full?: boolean
    @Prop({ type: Boolean, required: false }) public centred?: boolean
    @Prop({ type: Boolean, required: false }) public bordered?: boolean
    @Prop({ type: Boolean, required: false }) public outline?: boolean
    @Prop({ type: Boolean, required: false }) public round?: boolean
    @Prop({ type: String, required: false }) public icon?: string
    @Prop({ type: String, required: false }) public dataIdAttribute?: string
    @Prop({ type: String, default: 'button' }) public type!: Type
    @Prop({ type: Boolean, default: true })
    public readonly showSpinner!: boolean // show spinner when executing ajax request
    @Prop({ type: Boolean, default: false })
    public readonly forceToShowSpinner!: boolean // show spinner for some ajax request via SQS worker

    public executing = false

    public get getShowSpinner() {
        return this.forceToShowSpinner || (this.showSpinner && this.executing)
    }

    public async handleClick() {
        if (this.executing) {
            return
        }
        if (this.click) {
            this.executing = true
            try {
                await this.click()
            } finally {
                this.executing = false
            }
        }
    }
}
